import { useState, useEffect } from 'react';

type params = {
  /** The delay before the initial value is flipped */
  delay: number;
  /** The initial value */
  initial?: boolean;
  /** The amount of time before flipping the value again */
  toggle?: number;
};

export const useDelayedBoolean = ({ delay, initial = false, toggle }: params) => {
  const [isVisible, setIsVisible] = useState(initial);

  useEffect(() => {
    let toggleTimer: number;

    // Set initial delay
    const delayTimer = window.setTimeout(() => {
      setIsVisible(!initial);

      // If the toggle option is set flip the variable on this interval
      if (toggle) {
        toggleTimer = window.setInterval(() => {
          setIsVisible(visible => !visible);
        }, toggle);
      }
    }, delay);

    // Clear timers
    return () => {
      clearTimeout(delayTimer);

      if (toggle) {
        clearInterval(toggleTimer);
      }
    };
  }, [delay, initial, toggle]);

  return isVisible;
};
